import { useState } from 'react';
import { Tags as TagsIcon } from 'lucide-react';

import type { TagResumo } from '@/api/tags';
import { Button } from '@/components/ui/button';
import { TagChips } from '@/components/ui/tag-chip';

import { TagsDialog } from './TagsDialog';

interface TagSeletorProps {
  value: TagResumo[];
  onChange: (tags: TagResumo[]) => void;
  /** Título do diálogo ("Tags — <identificador>"). */
  identificador: string;
}

/**
 * Escolha de tags para um registro que ainda não existe (o documento sendo enviado):
 * os chips e o mesmo diálogo, só que guardando a escolha em vez de gravá-la.
 */
export function TagSeletor({ value, onChange, identificador }: TagSeletorProps) {
  const [aberto, setAberto] = useState(false);
  return (
    <div className="flex flex-wrap items-center gap-1">
      <TagChips tags={value} max={6} />
      <Button type="button" variant="outline" size="sm" className="h-11 sm:h-9" onClick={() => setAberto(true)}>
        <TagsIcon className="mr-2 h-4 w-4" />
        {value.length ? 'Alterar tags' : 'Escolher tags'}
      </Button>
      <TagsDialog
        open={aberto}
        onOpenChange={setAberto}
        identificador={identificador}
        aplicadas={value}
        onChange={onChange}
        // Sair para a tela de Tags descartaria o envio em andamento.
        mostrarLinkTela={false}
      />
    </div>
  );
}
